import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import {
  APPLICANT_DECISION_ACTION_LABEL_KEY,
  APPLICANT_DECISION_PRIMARY_ACTIONS,
  QA_NAME_APPLICANT_DECISION_ACTION,
} from '../ApplicantDecisionPanel.constants'

function ApplicantDecisionAction({ action, onClick }) {
  const { t } = useTranslation()

  const ActionButton = APPLICANT_DECISION_PRIMARY_ACTIONS.includes(action.key)
    ? Button.Contained
    : Button.Outlined

  function handleClick() {
    onClick(action.key)
  }

  return (
    <ActionButton
      disabled={Boolean(action.tooltipKey)}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_APPLICANT_DECISION_ACTION[action.key]}
      text={t(APPLICANT_DECISION_ACTION_LABEL_KEY[action.key])}
      tooltip={action.tooltipKey ? t(action.tooltipKey) : null}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      type='button'
      onClick={handleClick}
    />
  )
}

export default ApplicantDecisionAction
